var React = require('react');

function Laptop (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m4.4999 5.30005h15c.61 0 1.1.49 1.1 1.1v9.99995c0 .6065-.4844 1.0944-1.0895 1.1h2.4895c.33 0 .6.27.6.6s-.27.6-.6.6h-20c-.33 0-.6-.27-.6-.6s.27-.6.6-.6h2.48948c-.6051-.0056-1.08948-.4935-1.08948-1.1v-9.99995c0-.61.49-1.1 1.1-1.1zm.1 10.99995h14.8v-9.79995h-14.8z","fillRule":"evenodd"}));
}

Laptop.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Laptop;

Laptop.default = Laptop;
